export default __webpack_public_path__ + "19e74459fbb2cf8f64e02c59211bfb21.png";